<template>
  <nav class="bottom-nav">
    <router-link to="/welcome" class="nav-item" exact-active-class="active">
      <span class="nav-icon">🏠</span>
      <span class="nav-label">Home</span>
    </router-link>

    <router-link to="/crm" class="nav-item">
      <span class="nav-icon">👥</span>
      <span class="nav-label">Contacts</span>
    </router-link>

    <button @click="handleVoiceClick" class="nav-voice-btn" aria-label="Voice">
      <img src="@/assets/Nav Voice Button.png" alt="Voice" class="nav-voice-icon" />
    </button>

    <router-link to="/collateral" class="nav-item">
      <span class="nav-icon">📁</span>
      <span class="nav-label">Files</span>
    </router-link>

    <router-link to="/followups" class="nav-item">
      <span class="nav-icon">📬</span>
      <span class="nav-label">Follow Ups</span>
    </router-link>

    <!-- Voice Assistant Modal -->
    <VoiceAssistant
      v-if="showVoiceAssistant"
      @close="closeVoiceAssistant"
      @result="handleVoiceResult"
      @quick-action="handleQuickAction"
      @keyboard-input="handleKeyboardInput"
    />
  </nav>
</template>

<script>
import { mapActions } from 'vuex'
import VoiceAssistant from './VoiceAssistant.vue'

export default {
  name: 'BottomNavigation',
  components: {
    VoiceAssistant
  },
  data() {
    return {
      showVoiceAssistant: false
    }
  },
  beforeDestroy() {
    this.disconnectTranscription()
  },
  methods: {
    ...mapActions(['disconnectTranscription']),
    handleVoiceClick() {
      this.showVoiceAssistant = true
    },
    closeVoiceAssistant() {
      this.showVoiceAssistant = false
    },
    handleVoiceResult({ transcript, fields }) {
      console.log('=== VOICE RESULT ===')
      console.log('Transcript:', transcript)
      console.log('Extracted fields:', fields)
      console.log('====================')

      // Close the voice assistant after getting result
      this.showVoiceAssistant = false

      // TODO: Route to appropriate view based on intent
      // For now, just log the result
    },
    handleQuickAction(action) {
      console.log('Quick action selected:', action)
      this.showVoiceAssistant = false

      // Route to appropriate view based on action
      switch (action) {
        case 'Send Brochure':
          // TODO: Navigate to brochure sender
          break
        case 'Schedule Followup':
          this.$router.push('/followups/new')
          break
        case 'Get Insights':
          // TODO: Navigate to insights
          break
        case 'Schedule a meet':
          // TODO: Navigate to meeting scheduler
          break
      }
    },
    handleKeyboardInput() {
      console.log('Keyboard input requested')
      this.showVoiceAssistant = false
      // TODO: Open text input modal
    }
  }
}
</script>

<style scoped>
/* Bottom Navigation */
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0.75rem 0.5rem;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  text-decoration: none;
  color: #999;
  transition: all 0.3s;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  min-width: 60px;
}

.nav-item:hover,
.nav-item.active {
  color: #667eea;
}

.nav-item.active {
  background: #f8f9ff;
}

.nav-icon {
  font-size: 1.5rem;
}

.nav-label {
  font-size: 0.7rem;
  font-weight: 500;
}

.nav-voice-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  transition: all 0.3s;
  margin: 0 1rem;
  flex-shrink: 0;
  position: relative;
  transform: translateY(-8px); /* Slightly elevated */
}

.nav-voice-btn:hover {
  transform: translateY(-8px) scale(1.1);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.5);
}

.nav-voice-btn:active {
  transform: translateY(-8px) scale(1.05);
}

.nav-voice-icon {
  /* width: 32px;
  height: 32px; */
  object-fit: contain;
}

/* Responsive */
@media (max-width: 480px) {
  .nav-icon {
    font-size: 1.25rem;
  }

  .nav-voice-btn {
    width: 52px;
    height: 52px;
    margin: 0 0.5rem;
  }

  /* .nav-voice-icon {
    width: 28px;
    height: 28px;
  } */

  .nav-label {
    font-size: 0.65rem;
  }
}
</style>
